import * as React from 'react'
import { Typography } from '@lacedltd/laced-components'
import { useModal } from 'hooks'
import * as S from './ProductSaleItem.styles'
import { ProductBarcodesProps } from './ProductSaleItem.types'

const ProductBarcodes = ({ barcodes, title }: ProductBarcodesProps) => {
  const { Modal, toggleModal, modalProps } = useModal({
    align: 'center',
    justify: 'center',
    drawer: true
  })

  return (
    <>
      <S.MultipleBarcodes onClick={() => toggleModal()}>
        <Typography.Text variant="footnote">
          {barcodes.length} Barcodes
        </Typography.Text>
      </S.MultipleBarcodes>
      <Modal {...modalProps} width={475}>
        <S.BarcodeHeading as="h3">
          Barcodes ({barcodes.length})
        </S.BarcodeHeading>
        <S.BarcodeSubHeading variant="body" color="airJordan.p">
          {title.productName || title.label}
        </S.BarcodeSubHeading>
        <S.BarcodeList>
          {barcodes.map((barcode) => {
            return (
              <S.Barcode
                variant="footnote"
                color="airJordan.p"
                as="span"
                key={barcode}
              >
                {barcode}
              </S.Barcode>
            )
          })}
        </S.BarcodeList>
      </Modal>
    </>
  )
}

export default ProductBarcodes
